import React from 'react';
import { FaRegFileAlt, FaUndo, FaClipboardCheck, FaExclamationTriangle, FaCalendarAlt, FaShieldAlt } from 'react-icons/fa';

const RefundPolicy = () => {
    return (
        <div className="bg-gray-50 min-h-screen py-16 px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl mx-auto">
                {/* Header Section */}
                <div className="bg-gradient-to-r from-blue-600 to-indigo-700 rounded-t-2xl p-10 text-white text-center shadow-lg">
                    <h1 className="text-4xl font-bold mb-4 text-white">취소 및 환불 규정</h1>
                    <p className="text-blue-100 text-lg">워크웨이 서비스의 투명하고 공정한 환불 정책을 안내해 드립니다.</p>
                </div>

                {/* Main Content Card */}
                <div className="bg-white rounded-b-2xl shadow-xl overflow-hidden p-8 md:p-12 border-x border-b border-gray-100">
                    
                    {/* section 1: Cancellation */}
                    <section className="mb-12">
                        <div className="flex items-center mb-6">
                            <div className="bg-blue-100 p-3 rounded-xl mr-4">
                                <FaUndo className="text-blue-600 text-2xl" />
                            </div>
                            <h2 className="text-2xl font-bold text-gray-800">1. 구독 취소 안내</h2>
                        </div>
                        <div className="bg-blue-50 border-l-4 border-blue-500 p-5 rounded-r-xl space-y-4">
                            <p className="text-gray-700 leading-relaxed">
                                사용자는 언제든지 서비스 구독을 취소할 수 있습니다. 
                            </p>
                            <div className="grid md:grid-cols-2 gap-4">
                                <div className="bg-white p-4 rounded-lg shadow-sm">
                                    <span className="inline-block text-blue-600 font-bold mb-2">월간 구독 (1개월)</span>
                                    <p className="text-sm text-gray-600">취소 시 다음 달 결제 예정일에 자동 결제가 중단되며, 현재 결제된 주기의 종료일까지 서비스를 이용하실 수 있습니다.</p>
                                </div>
                                <div className="bg-white p-4 rounded-lg shadow-sm border-2 border-blue-200">
                                    <span className="inline-block text-blue-600 font-bold mb-2">연간 구독 (1년 약정)</span>
                                    <p className="text-sm text-gray-600">취소 시 다음 연도 재계약 시점에 자동 갱신되지 않도록 설정됩니다. 계약된 <strong>1년의 약정 기간이 종료될 때까지</strong> 서비스는 동일하게 유지됩니다.</p>
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* section 2: Refund Policy */}
                    <section className="mb-12">
                        <div className="flex items-center mb-6">
                            <div className="bg-green-100 p-3 rounded-xl mr-4">
                                <FaRegFileAlt className="text-green-600 text-2xl" />
                            </div>
                            <h2 className="text-2xl font-bold text-gray-800">2. 환불 기준</h2>
                        </div>
                        <div className="bg-amber-50 border-l-4 border-amber-500 p-5 rounded-r-xl mb-6">
                            <p className="text-gray-700 text-sm leading-relaxed">
                                워크웨이는 <strong>충분한 무료 체험(30일)</strong> 기간을 제공하고 있습니다. 유료 결제 및 정식 서비스 이용이 시작된 이후에는 디지털 서비스 특성상 원칙적으로 <strong>중도 해지에 따른 환불이 불가능</strong>합니다. 무료 체험 기간 동안 서비스를 충분히 검토하신 후 신중히 결정해 주시기 바랍니다.
                            </p>
                        </div>
                        <div className="overflow-hidden border border-gray-100 rounded-xl shadow-sm">
                            <table className="min-w-full divide-y divide-gray-200">
                                <thead className="bg-gray-50">
                                    <tr>
                                        <th className="px-6 py-4 text-left text-sm font-semibold text-gray-600">서비스 상태</th>
                                        <th className="px-6 py-4 text-left text-sm font-semibold text-gray-600">환불 규정</th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-100">
                                    <tr>
                                        <td className="px-6 py-4 text-sm font-medium text-gray-800">무료 체험 기간 중</td>
                                        <td className="px-6 py-4 text-sm text-green-600 font-bold">언제든지 해지 가능 (비용 발생 없음)</td>
                                    </tr>
                                    <tr>
                                        <td className="px-6 py-4 text-sm font-medium text-gray-800">정식 서비스 이용 시 (결제 후)</td>
                                        <td className="px-6 py-4 text-sm text-red-600 font-bold">환불 불가</td>
                                    </tr>
                                    <tr>
                                        <td className="px-6 py-4 text-sm font-medium text-gray-800">회사 귀책 사유로 인한 서비스 중단</td>
                                        <td className="px-6 py-4 text-sm text-blue-600 font-bold">잔여 기간 비례 전액 환불</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </section>

                    {/* section 3: Procedure */}
                    <section className="mb-12">
                        <div className="flex items-center mb-6">
                            <div className="bg-purple-100 p-3 rounded-xl mr-4">
                                <FaClipboardCheck className="text-purple-600 text-2xl" />
                            </div>
                            <h2 className="text-2xl font-bold text-gray-800">3. 환불 신청 및 처리</h2>
                        </div>
                        <div className="space-y-4 text-gray-600">
                            <p>모든 환불 신청은 다음 채널을 통해 공식 접수해 주셔야 합니다.</p>
                            <div className="bg-gray-50 p-6 rounded-2xl flex flex-col md:flex-row gap-6 justify-around">
                                <div className="text-center">
                                    <span className="block text-xs text-gray-400 mb-1 uppercase tracking-widest">Email</span>
                                    <a href="mailto:workway.help@workway.co.kr" className="text-blue-600 font-bold hover:underline">workway.help@workway.co.kr</a>
                                </div>
                                <div className="text-center">
                                    <span className="block text-xs text-gray-400 mb-1 uppercase tracking-widest">Processing Time</span>
                                    <span className="text-gray-800 font-bold font-bold">영업일 기준 3~5일 소요</span>
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* Footer Policy Info */}
                    <div className="mt-16 pt-8 border-t border-gray-100 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400">
                        <div className="flex items-center gap-4">
                            <span>시행일: 2024년 1월 1일</span>
                            <span className="w-1 h-1 bg-gray-300 rounded-full"></span>
                            <span className="text-gray-600 font-medium">최종 수정일: 2024년 12월 26일</span>
                        </div>
                        <p>© 주식회사 워크웨이</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RefundPolicy;
